export const URLs = {
  help: process.env['REACT_APP_NUCLEUS_HELP_URL'],
  tools: process.env['REACT_APP_NUCLEUS_TOOLS_URL'],
  blog: process.env['REACT_APP_NUCLEUS_BLOG_URL'],
  playbook: process.env['REACT_APP_NUCLEUS_PLAYBOOK_URL'],
  app: process.env['REACT_APP_NUCLEUS_APP_URL'],
  admin: `${process.env['REACT_APP_NUCLEUS_APP_URL']}/admin`,
  register: 'https://the167.mykajabi.com/offers/eLaMztop',
  login: 'https://the167.mykajabi.com/login',
  demo: `${process.env['REACT_APP_NUCLEUS_APP_URL']}/demo-light`,
};

export const KEYs = {
  intercomAppId: process.env['REACT_APP_INTERCOM_APP_ID'],
  helpscountAppId: process.env['REACT_APP_HELPSCOUNT_ID'],
  facebookPixelId: process.env['REACT_APP_FACEBOOK_PIXEL_ID'],
};

export const PRODUCTs = {
  complete: 'complete',
  web: 'website',
  sermonEngine: 'sermon_engine',
};

export const Colors = {
  Primary: '#FF1F1F',
  PrimaryDark: '#B31616',
  PrimaryLight: '#FFEDED',
  PrimaryLight2: '#FFF7F7',
};

export const Counts = {
  TotalSpots: process.env['REACT_APP_COUNTS_TOTAL_SPOTS'] || '75',
  RemainingSpots: process.env['REACT_APP_COUNTS_REMAINING_SPOTS'] || '75',
};

export const EnrollmentEndsAt = Date.parse(process.env['REACT_APP_ENROLLMENT_ENDS_AT'] || '2020-05-26T17:00:00Z');

export const BILLING_API_URL = process.env['REACT_APP_BILLING_API_URL'];
export const NUCLEUS_BASE_URL = process.env['REACT_APP_NUCLEUS_BASE_URL'];
export const NUCLEUS_ADMIN_BASE_URL = process.env['REACT_APP_NUCLEUS_ADMIN_BASE_URL'];
export const PLATFORM_API_URL = process.env['REACT_APP_PLATFORM_API_URL'];
export const REBEL_PAY_API_URL = process.env['REACT_APP_REBEL_PAY_API_URL'];
export const MEDIA_APP_URL = process.env['REACT_APP_NUCLEUS_MEDIA_URL'];

export const REBEL_GIVE_MERCHANT_ID = process.env['REACT_APP_REBEL_GIVE_MERCHANT_ID'];
export const REBEL_PAY_PUBLIC_API_KEY = process.env['REACT_APP_REBEL_PAY_PUBLIC_API_KEY'];
export const GIVING_FLOW_BASE_URL = process.env['REACT_APP_GIVING_FLOW_BASE_URL'];
export const FACEBOOK_PIXEL_ID = process.env['REACT_APP_FACEBOOK_PIXEL_ID'];
export const MAILCHIMP_URL = process.env['REACT_APP_MAILCHIMP_URL'];
export const INTERCOM_APP_ID = process.env['REACT_APP_INTERCOM_APP_ID'];

export const OG_IMAGE = 'https://www.the167.cc/og-launch.jpg';



// WEBPACK FOOTER //
// ./src/constants/index.js